export const validNumber = /^[0]+$/;
